module.exports = __webpack_public_path__ + "assets/img/65p_316_2.93f45523.jpg";